import React, { useState , useContext, useEffect  , useRef} from 'react'
import BarChart from './BarChart'
import {
useNavigate,
useLocation
} from "react-router-dom";
import Progresbbar from '../Statistics/Progresbbar';
import ProgresbarHead from './ProgresbarHead';
import DataFetch from '../../Context/DataFetch';
import moment from 'moment';
import MultiProgress from 'react-multi-progress'
import Language from '../../Context/Language'

export default function BeetweenMatch() {
  const navigate = useNavigate()
  const location = useLocation()
  const {MacthDataBetween} = useContext(DataFetch);
  const [HomeGf , setHomeGf] = useState("")
  const [HomeGA , setHomeGA] = useState("")
  const [HomeWon , setHomeWon] = useState(0)
  const [AwayWon , setAwayWon] = useState(0)
  const [Drawn , setDrawn] = useState(0)
  const {data} = useContext(DataFetch);
  const {data1} = useContext(DataFetch);
  const {data2} = useContext(DataFetch);
  const {MacthCount} = useContext(DataFetch);
  const dataLang = useContext(Language)



    const AvreageMatch = (Goal ,Match) => {
         return ( Goal /Match).toFixed(2);
    }

    const PercentageCal=(a,b ,c)=> {
      return (b/ (a + b +c ))*100
    }


    function addDefaultSrc(ev){
      ev.target.src = '/CountryFlag/world.png'
    }

    const changeBackground=(a) => e => {
      if(e.target.offsetWidth < e.target.scrollWidth) {
        e.target.setAttribute('data-tooltip', a);
      }
      else{
        
      }

    }

    const ref = useRef(null);

    useEffect(() => {
      setHomeGf(MacthDataBetween.reduce((accumulator, object) => {
        return accumulator + (data.homeTeamId === object.home_Team_Id ? object.home_Score : object.away_Score  )
      }, 0))

      setHomeGA(MacthDataBetween.reduce((accumulator, object) => {
        return accumulator + (data.awayTeamId === object.away_Team_Id?  object.away_Score :object.home_Score  ) 
      }, 0))
      setHomeWon(MacthDataBetween.reduce((accumulator, object) => {
        return accumulator + (data.homeTeamId === object.winner_Id ?  1 :0 ) 
      }, 0))

      setAwayWon(MacthDataBetween.reduce((accumulator, object) => {
        return accumulator + (data.awayTeamId === object.winner_Id ?  1 :0 ) 
      }, 0))

      setDrawn(MacthDataBetween.reduce((accumulator, object) => {
        return accumulator + (object.winner_Id === 0  ?  1 :0 ) 
      }, 0))


    })


  return (

    MacthDataBetween.length !== 0 ?
    <div className='BetweenMatchContainer'>
      
        <div id='SlideDownDiv' className='BetweenMatchHeader'><div className='BetweenMatchHeaderText'>{dataLang[sessionStorage.getItem("lang")].Lastmeetings}</div></div>
        <div className='BetweenMatchArea'>
          <div id='HomeBetween' className='HomeBeetweenGoal'>
            <div className='GoalArea'>
              <div className='GoalAreaHeader'><div className='GoalHeaderTextDiv'>{dataLang[sessionStorage.getItem("lang")].GF}</div></div>
              <div className='GoalWebText'>{HomeGf}</div>
            </div>
        
            <div className='GoalArea'>
              <div className='GoalAreaHeader'><div className='GoalHeaderTextDiv'>{dataLang[sessionStorage.getItem("lang")].GA}</div></div>
              <div className='GoalWebText'>{HomeGA}</div>
            </div>
            <div className='GoalArea'>
              <div className='GoalAreaHeader'> <div className='GoalHeaderTextDiv'>{dataLang[sessionStorage.getItem("lang")].AverageGoal}</div></div>
              <div className='GoalWebText'>{AvreageMatch(HomeGf,MacthCount)}</div>
            </div>
          </div>
          <div className='BeetweenMatchesDiv'>
          <div className='BetweenMatches'>
            <div className='BetweenMatchesHeader'>
              <div className='BetweenMatchesHeaderDate'>{dataLang[sessionStorage.getItem("lang")].Date}</div>
              <div className='BetweenMatchesHeaderRound'>{dataLang[sessionStorage.getItem("lang")].Round}</div>
              <div className='BetweenMatchesHeaderMatch'>{dataLang[sessionStorage.getItem("lang")].Match}</div>
              <div className='BetweenMatchesHeaderTournament'>{dataLang[sessionStorage.getItem("lang")].Tournament}</div>
              <div className='ImageDivArea'></div>
            </div>
            {
            MacthDataBetween.map(function(item, i){
                 return  <div key={i} onClick={()=> navigate(`/Statistics/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/${sessionStorage.getItem("lang")}`, {state:{MatchData:MacthDataBetween[i]}})}  className='BetweenMatchesTable'>
                 <div className='BetweenMatchesTables'>
                   <div className='BetweenMatchesDate'>{moment(item.start_Time).format("DD/MM/YY")}</div>
                   <div className='BetweenMatchesRound'>{item.round_Number}</div>
                   <div className='BetweenMatchesMatch'>
                     <div className='HomeTeamBetweenMatchesArea'>
                       <div className='BetweenMatchesTeamName'>{item.home_Team_Name}</div>
                       <div className='BetweenMatchesScoreNumber'><span id={item.winner_Id === 0 || item.winner_Id !== item.home_Team_Id ? 'BetScore' :'ScoreGreen'}>{item.home_Score}</span></div>
                     </div>
                     <div className='BetwwenMatchesTeamSpan'>-</div>
                     <div className='AwayTeamBetweenMatchesArea'>
                       <div className='BetweenMatchesScoreNumber'><span id={item.winner_Id === 0 || item.winner_Id !== item.away_Team_Id ? 'BetScore' :'ScoreGreen'}>{item.away_Score}</span></div>
                       <div className='BetweenMatchesTeamName'>{item.away_Team_Name}</div>
                     </div>
                   </div>
             
                   <div  ref={ref} className="tooltip BetweenMatchesTournament"  >
                        <div onMouseOver={changeBackground(item.competitionName)}  className="BeetweenMatchTextTool">{item.competitionName}</div>
                    </div>
                     
                   <img src="/next.png" className='nextStyleImAGE' width={17}></img> 
                 </div>
                 </div>
              })
            }
          </div>
          <div className='BeetweenMatchDivProgress'>
            <div className='BeetweenMatchProgressLine'>
                 <div  style={{width:PercentageCal(Drawn, HomeWon , AwayWon)+"%"}}><img src={`https://cdn-images.nvpark.com/logo/${data.homeTeamId}.png`}  onError={addDefaultSrc}  width={25} height={25}></img><div className='BeetweenSpanOran'><div>({PercentageCal(Drawn, HomeWon , AwayWon).toFixed(0)+"%"})</div><div>{HomeWon}</div><div className='BetwwenPercentage'>{dataLang[sessionStorage.getItem("lang")].W}</div></div></div>
                 <div style={{ width:PercentageCal(HomeWon, Drawn,   AwayWon)+"%"}}><div className='BeetweenSpanOran'><div>({(PercentageCal(HomeWon, Drawn,   AwayWon).toFixed(0)+"%")})</div><div>{Drawn}</div><div className='BetwwenPercentageDrawn'>{dataLang[sessionStorage.getItem("lang")].D}</div></div></div>
                 <div  style={{width:PercentageCal(HomeWon, AwayWon , Drawn )+"%"}}><img src={`https://cdn-images.nvpark.com/logo/${data.awayTeamId}.png`}  onError={addDefaultSrc}  width={25} height={25}></img><div className='BeetweenSpanOran'><div>({PercentageCal(HomeWon, AwayWon , Drawn).toFixed(0)+"%"})</div><div>{AwayWon}</div><div className='BetwwenPercentage'>{dataLang[sessionStorage.getItem("lang")].W}</div></div></div>
            </div>
          <MultiProgress
          transitionTime={2}
          
			           elements={[
			             	{
				           	  value: PercentageCal(Drawn, HomeWon , AwayWon),
				             	color: "#262d47"
				            },
                    {
                      value: PercentageCal(HomeWon, Drawn,   AwayWon),
                      color: "#ebebeb",
                   },
                   {
                    value: PercentageCal(HomeWon, AwayWon , Drawn ),
                    color:"#3e98c7"
                 },
			            ]}
		          />
          </div>

          </div>

     
          <div id='AwayBetween' className='HomeBeetweenGoal'>
            <div className='GoalArea'>
              <div className='GoalAreaHeader'><div className='GoalHeaderTextDiv'>{dataLang[sessionStorage.getItem("lang")].GF}</div></div>
              <div className='GoalWebText'>{HomeGA}</div>
            </div>
            <div className='GoalArea'>
              <div className='GoalAreaHeader'><div className='GoalHeaderTextDiv'>{dataLang[sessionStorage.getItem("lang")].GA}</div></div>
              <div className='GoalWebText'>{HomeGf}</div>
            </div>
            <div className='GoalArea'>
              <div className='GoalAreaHeader'><div className='GoalHeaderTextDiv'>{dataLang[sessionStorage.getItem("lang")].AverageGoal}</div></div>
              <div className='GoalWebText'>{AvreageMatch(HomeGA,MacthCount)}</div>
            </div>
          </div>
  
        </div>
        <div className='MobileBetweenMatchArea'>
        <div className='MobileHomeBeetweenGoal'>
            <div className='GoalArea'>
            <ProgresbarHead 
              HomeColor="#262d47"
               AwayColor="#3e98c7"
                Home={HomeGf} Away={HomeGA} Title={dataLang[sessionStorage.getItem("lang")].GoalForward} />
            </div>
            <div className='GoalArea'>
              <ProgresbarHead 
              HomeColor="#262d47"
               AwayColor="#3e98c7"
                Home={HomeGA} Away={HomeGf} Title={dataLang[sessionStorage.getItem("lang")].GoalAgainst} />
            </div>
            <div className='GoalArea'>
                 <ProgresbarHead 
               HomeColor="#262d47"
                  AwayColor="#3e98c7"
                     Home={AvreageMatch(HomeGf,MacthCount)} Away={AvreageMatch(HomeGA,MacthCount)} Title={dataLang[sessionStorage.getItem("lang")].AverageGoal}  />
            </div>
          </div>
        </div>
    </div>
    :
        <div className='BetweenMatchContainer'>
        <div id='SlideDownDiv' className='BetweenMatchHeader'><div className='BetweenMatchHeaderText'>{dataLang[sessionStorage.getItem("lang")].Lastmeetings}</div></div>
        <div className='BetweenMatchArea'>
           <div className='TheseTeamsFirst'>{dataLang[sessionStorage.getItem("lang")].Theseteamsmeetforthefirsttime}</div>
        </div>
    </div>
  )
}



// <div className='BetweenScoreArea displayTeamArea'>
// <span className='GreenScore'>2</span><span className='RedScore'>0</span>
// </div>